// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@tps/App/SharedStyles/CartLineSharedStyles";
import { requestRmaProductListStyles } from "@tps/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

requestRmaProductListStyles.productTotalPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

requestRmaProductListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

requestRmaProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

requestRmaProductListStyles.returnReasonSelect = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 10px;
        `,
        formInputWrapper: css`
            max-width: 200px;
            width: 100%;
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        `,
    },
};

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formField: css`
            width: 125px;
            margin-right: auto;
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
        formInputWrapper: css`
            width: 90px;
        `,
    },
};

requestRmaProductListStyles.actionsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};

requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-top: 25px;
        margin-bottom: 25px;
    `,
};

requestRmaProductListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

requestRmaProductListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

requestRmaProductListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

requestRmaProductListStyles.orderLineCardImage = {
    css: css`
        ${cartLineSharedStyles?.productImage?.linkWrappingImage?.css}
    `,
};

requestRmaProductListStyles.priceWrapper = {
    ...cartLineSharedStyles?.productPrice?.wrapper,
};

requestRmaProductListStyles.linesHeader = {
    total: {
        css: css`
            text-align: left;
        `,
    },
};
requestRmaProductListStyles.cartLineContainer = {
    total: {
        css: css`
            padding: 0 12px 0 20px;
            text-align: left;
        `,
    },
};
